var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.span.loading)?_c('v-progress-linear',{attrs:{"absolute":"","indeterminate":""}}):_vm._e(),(_vm.span.data)?_c('SpanCard',{attrs:{"date-range":_vm.dateRange,"span":_vm.span.data,"fluid":_vm.$vuetify.breakpoint.mdAndDown}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }